import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../lib/i18next";
import CampaignApprovalCommentCard from "../../pages/NewAdsCampaign/components/CampaignApproval/CampaignApprovalCommentCard";
import {
  formatContentApprovalRelativeTime,
  getContentApprovalCreativeNumber,
} from "./contentApprovalUtils";
import { CONTENT_APPROVAL_COMMENT_CREATIVE_NUMBER } from "../../i18n/keysTranslations";

const ContentApprovalCommentList = ({
  comments = [],
  contentIDs = [],
  showCreativeLabel = true,
  emptyText = "—",
  centeredEmpty = false,
}) => {
  const { t, i18n } = useTranslationApp();
  const language = i18n?.language || "es";

  if (comments.length === 0) {
    if (centeredEmpty) {
      return (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 200,
            px: 2,
            py: 4,
            textAlign: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            {emptyText}
          </Typography>
        </Box>
      );
    }

    return (
      <Typography variant="body2" color="text.secondary">
        {emptyText}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {comments.map((comment) => {
        const relativeTime = formatContentApprovalRelativeTime(
          comment?.createdAt,
          language
        );
        const creativeNumber = showCreativeLabel
          ? getContentApprovalCreativeNumber(contentIDs, comment?.contentID)
          : null;

        const creativeLabel =
          showCreativeLabel && creativeNumber
            ? t(CONTENT_APPROVAL_COMMENT_CREATIVE_NUMBER, {
                number: creativeNumber,
              })
            : "";
        const authorLabel = comment?.reviewerEmail?.trim?.() || "";

        return (
          <Box key={comment.id}>
            {relativeTime ? (
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: "block", mb: 0.5 }}
              >
                {relativeTime}
              </Typography>
            ) : null}
            <CampaignApprovalCommentCard
              variant="general"
              headerLabel={creativeLabel}
              reviewerEmail={authorLabel}
              body={comment?.body || ""}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default ContentApprovalCommentList;
